module.exports = __webpack_public_path__ + "img/coupon-runout.0e4f4101.png";